import Head from "next/head";

interface HeadPageProps {
  title: string;
  description: string;
  children?: any;
}

export function HeadPage({ title, description, children }: HeadPageProps) {
  return (
    <Head>
      <title>{title}</title>
      <meta name="og:title" content={title} />
      <meta name="description" content={description} />
      <meta name="og:description" content={description} />
      <link rel="icon" href="/favicon.ico" />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href="/favicon-32x32.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href="/favicon-16x16.png"
      />
      {children}
    </Head>
  );
}

export default HeadPage;
